import { PageContentWrapper } from 'app/member/layouts/wrapper/page-content';
import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import SlidingNav from 'app/shared/nav/sliding/sliding';
import { Spacer } from 'app/member/layouts/generic';
import { useDispatch } from 'react-redux';
import { setPageTitle } from 'store/actions/header';
import { PlansModule } from './plans';
import { EarningsModule } from './earnings';
import { PayoutsModule } from './payouts';
import PaymentModule from './payments/_index';
import CurrencyListModule from './currency/_index';
import { SubscriptionsModule } from './subscriptions';

const NAVITEMS = [
  {
    title: 'Modules',
    path: '/billings/modules'
  },
  {
    title: 'Subscriptions',
    path: '/billings/subscriptions'
  },
  {
    title: 'Payments',
    path: '/billings/payments'
  },
  {
    title: 'Currencies',
    path: '/billings/currencies'
  },
  {
    title: 'Earnings',
    path: '/billings/earnings'
  },
  {
    title: 'Pending Payouts',
    path: '/billings/payouts'
  }
];

export const BillingModule = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setPageTitle([{ title: 'Billing', path: '.' }]));
  }, []);

  return (
    <PageContentWrapper>
      <SlidingNav nav_items={NAVITEMS} />
      <Spacer multiple={4} />
      <Routes>
        <Route path="currencies" element={<CurrencyListModule />} />
        <Route path="earnings" element={<EarningsModule />} />
        <Route path="payouts" element={<PayoutsModule />} />
        <Route path="payments" element={<PaymentModule />} />
        <Route path="subscriptions" element={<SubscriptionsModule />} />
        <Route index path="modules/*" element={<PlansModule />} />
      </Routes>
    </PageContentWrapper>
  );
};
